/**
 * group-list.js
 */

import React from 'react';
import { Link as MuiLink } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Link } from 'react-router-dom';
import DataGrid from 'components/data-grid';


const useStyles = makeStyles(theme => ({
  grid: {
    '& .MuiDataGrid-cell.link': {
      padding: 0
    },
    '& .MuiDataGrid-cell.disabled': {
      color: theme.palette.text.disabled
    }
  },
  cellLink: {
    flex: 1,
    display: 'flex',
    justifyContent: 'inherit',
    color: 'inherit',
    padding: `0 ${theme.spacing(1.5)}`,
    overflow: 'hidden',
    '&:hover': {
      textDecoration: 'none'
    }
  },
}));


export default function GroupList(props) {
  const {
    columns,
    rows,
    rowUrl,
    width,
    ...rest
  } = props;
  const classes = useStyles();
  const linkifiedColumns = React.useMemo(() => columns.map(def => ({
    ...def,
    renderCell: (params) => {
      const to = rowUrl(params.row);
      if (to) {
        return (
          <MuiLink
            component={Link}
            className={classes.cellLink}
            to={rowUrl(params.row)}
            children={def.renderCell?.(params) || params.value || <>&nbsp;</>}
            underline="hover" />
        );
      } else {
        return def.renderCell?.(params);
      }
    }
  })), [columns, classes, rowUrl]);


  return (
    <DataGrid
      columns={linkifiedColumns}
      rows={rows}
      width={width}
      maxHeight={406} // shows 8 rows
      className={classes.grid}
      headerHeight={44}
      disableColumnMenu
      disableRowSelectionOnClick
      hideFooter
      slots={{ NoRowsOverlay: () => <></> }}
      getCellClassName={params => {
        const to = rowUrl(params.row);
        return to 
          ? 'link' : 
          params.field !== 'menu'
            ? 'disabled'
            : '';
      }}
      {...rest}
    />
  )
}